import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/repair/page', Object.assign({}, options, { params }));

export const poolPage = (params, options) =>
  request.get('/api/repair/poolPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/repair/selectOne', Object.assign({}, options, { params }));
export const getPrint = (params, options) =>
  request.get('/api/repair/selectOnePrint', Object.assign({}, options, { params }));
// 获取反映来源下拉框数据
export const source = (params, options) =>
  request.get(
    '/api/blade-system/dict/dictionary?code=complaint_source',
    Object.assign({}, options, { params })
  );

// 获取反映形式下拉框数据
export const manageType = (params, options) =>
  request.get(
    '/api/blade-system/dict/dictionary?code=complaint_manage_type',
    Object.assign({}, options, { params })
  );

// 获取处理部门下拉框数据
export const selectDept = (params, options) =>
  request.get('/api/repair/selectDept', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/repair/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/repair/submit', params, options);

export const update = (params, options) => request.post('/api/repair/submit', params, options);

export const update1 = (params, options) => request.post('/api/repair/manageSave', params, options);

export const update2 = (params, options) =>
  request.post('/api/repair/manageCommit', params, options);

export const getRepairLogById = (params, options) =>
  request.post('/api/repair/getRepairLogById', params, options);

export const close = (params, options) =>
  request.get('/api/repair/close', Object.assign({}, options, { params }));

export const get = (params, options) =>
  request.get('/api/repair/get', Object.assign({}, options, { params }));

export const designate = (params, options) =>
  request.get('/api/repair/designate', Object.assign({}, options, { params }));

export const queryPage = (params, options) =>
  request.get('/api/repair/queryPage', Object.assign({}, options, { params }));

export const repairRollBack = (params, options) =>
  request.post('/api/repair/repairRollBack', params, options);

export const listByProperty = (params, options) =>
  request.get('/api/repair/listByProperty', Object.assign({}, options, { params }));

export const getCommunity = (params, options) =>
  request.get('/api/base/property/getCommunity', Object.assign({}, options, { params }));
